// extracted by mini-css-extract-plugin
export var breadcrumb = "breadcrumbs-module--breadcrumb--363cb";
export var breadcrumbs = "breadcrumbs-module--breadcrumbs--3ab55";
export var breadcrumbsComponent = "breadcrumbs-module--breadcrumbsComponent--2bcd6";
export var charcoal = "breadcrumbs-module--charcoal--c0e7c";
export var container = "breadcrumbs-module--container--2da65";
export var dark = "breadcrumbs-module--dark--19195";
export var lastBreadcrumb = "breadcrumbs-module--lastBreadcrumb--1b594";
export var light = "breadcrumbs-module--light--a2ac5";
export var lightSand = "breadcrumbs-module--lightSand--31de8";
export var spacer = "breadcrumbs-module--spacer--144f5";